module.exports = __webpack_public_path__ + "static/img/pupil-drinking--small.3304b8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/canteen/pupil-drinking--small.svg
// module id = 151
// module chunks = 2